// GET LOCATION
export const GET_LOCATION_LIST = 'GET_LOCATION_LIST';
export const GET_LOCATION_LIST_SUCCESS = 'GET_LOCATION_LIST_SUCCESS';
export const GET_LOCATION_LIST_FAILED = 'GET_LOCATION_LIST__FAILED';

// EXPORT LOCATION
export const EXPORT_LOCATION_LIST = 'EXPORT_LOCATION_LIST';
export const EXPORT_LOCATION_LIST_SUCCESS = 'EXPORT_LOCATION_LIST_SUCCESS';
export const EXPORT_LOCATION_LIST_FAILED = 'EXPORT_LOCATION_LIST_FAILED';

// DELETE LOCATION
export const DELETE_LOCATION = 'DELETE_LOCATION';
export const DELETE_LOCATION_SUCCESS = 'DELETE_LOCATION_SUCCESS';
export const DELETE_LOCATION_FAILED = 'DELETE_LOCATION_FAILED';

// ADVANCE BOOKING CHARTS
export const GET_ADVANCE_BOOKING_CHARTS = 'GET_ADVANCE_BOOKING_CHARTS';
export const GET_ADVANCE_BOOKING_CHARTS_SUCCESS = 'GET_ADVANCE_BOOKING_CHARTS_SUCCESS';
export const GET_ADVANCE_BOOKING_CHARTS_FAILED = 'GET_ADVANCE_BOOKING_CHARTS_FAILED';

// STAY NIGHTS CHARTS
export const GET_STAY_NIGHTS_CHARTS = 'GET_STAY_NIGHTS_CHARTS';
export const GET_STAY_NIGHTS_CHARTS_SUCCESS = 'GET_STAY_NIGHTS_CHARTS_SUCCESS';
export const GET_STAY_NIGHTS_CHARTS_FAILED = 'GET_STAY_NIGHTS_CHARTS_FAILED';

// BOOKING STATUS RATIO
export const GET_BOOKING_STATUS_RATIO = 'GET_BOOKING_STATUS_RATIO';
export const GET_BOOKING_STATUS_RATIO_SUCCESS = 'GET_BOOKING_STATUS_RATIO_SUCCESS';
export const GET_BOOKING_STATUS_RATIO_FAILED = 'GET_BOOKING_STATUS_RATIO_FAILED';

// REVENUE DISTRIBUTION ACCOUNT LEVELS
export const GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS = 'GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS';
export const GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS_SUCCESS = 'GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS_SUCCESS';
export const GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS_FAILED = 'GET_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS_FAILED';
